export default {
    // 路由地址
    getRouteList: '/mall/permis/all-list', // 获取路由列表
    addRouteInfo: '/mall/permis/create-update', // 添加、修改路由信息

    UnifiedLogin: '/yv2/token/UnifiedLogin', //登录
    GetUserInfoByUserId: '/yv2/api/GetUserInfoByUserId', // token取用户信息
    getUserInfo: '/mall/common/user-info', // 获取用户信息

    address: 'https://files.sciconf.cn/modules/address.js?v=3.8.9', //地址
    iconUrl: 'http://files.sciconf.cn/asset/module/fonticonpicker/icon-config.js?v=4.3.5',
    getVideoSubjectList: '/yv2/subject/list', // 获取学科列表
    getPinyin: '/mall/program/get-pinyin', // 获取拼音

    uploadImage:
        (process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API_BASE_URL + '/mall/common/upload-image' : process.env.VUE_APP_API_BASE_URL + '/mall/common/upload-image') + '?v=' + +new Date(),

    // 获取会议基本信息
    getMeetingInfo: '/mall/common/meeting',
    // 路由权限
    getMenu: '/mall/permis/menu',
    // 获取下载数量
    getDownNumber: '/mall/download/downloading-statistics',
    // 获取下载列表
    getDownList: '/mall/download/list',
    // 获取币种下拉
    getCurrencyType: '/mall/common/get-currency-type',

    /**********************  酒店相关  **************************/
    getHotelBookStatistics: '/mall/hotel/book-statistics', // 获取酒店预订统计
    getHotelInOutStatistics: '/mall/hotel/check-in-out-statistics', // 酒店入住离店日期统计
    getHotelList: '/mall/hotel/hotel-list', // 获取酒店列表
    getHotelDetail: '/mall/hotel/get-hotel-info', // 获取酒店信息
    editHotel: '/mall/hotel/edit-hotel', // 编辑酒店
    addHotel: '/mall/hotel/add-hotel', // 新增酒店
    delHotel: '/mall/hotel/del-hotel',
    getRoomDetail: '/mall/hotel/get-room-info', // 获取房型信息
    delRoom: '/mall/hotel/del-hotel-room', // 删除房型
    editRoom: '/mall/hotel/edit-room', // 编辑房型
    addRoom: '/mall/hotel/add-room', // 添加房型
    getHotelConfig: '/mall/hotel/get-config', //获取酒店配置
    setHoteLConfig: '/mall/hotel/set-config', //酒店参数配置
    getHoteOrderlList: '/mall/order/hotel-order-list', //酒店订单列表
    getHoteOrderlDetail: '/mall/order/hotel-order-detail', //酒店订单详情
    editPayStatus: '/mall/order/edit-pay-status', //修改订单支付状态
    editRefund: '/mall/order/edit-refund', //操作退款
    getOrderInfoDetail: '/mall/invoice/get-invoice-details', //订单发票详情
    geyInvoiceChannelList: '/mall/invoice/hotel-inv-channel', //发票列表
    getHotelChannelInvInfo: '/mall/invoice/hotel-channel-inv-info', //酒店发票渠道参数配置信息
    setHotelChannelInvEdit: '/mall/invoice/hotel-edit-eax', //酒店渠道发票参数编辑
    getInvoiceTaxList: '/mall/invoice/get-tax', //发票服务项目 税率
    getInvoiceProductList: '/mall/invoice/product-list', //酒店发票服务项目列表
    delInvoiceProduct: '/mall/invoice/product-del', //酒店渠道发票服务项目删除
    getHeadNode: '/mall/invoice/tax-class-head-node', //酒店发票税收一级分类
    getHeadCategory: '/mall/invoice/tax-class-category', //酒店发票税收分类
    getTaxChildTable: '/mall/invoice/tax-class-query-child', //酒店发票获取子级税收分类编码 表格
    getInvoiceProductDetail: '/mall/invoice/product-detail', //发票服务项目详情
    addInvoiceProduct: '/mall/invoice/product-add', //发票服务项目新增
    editInvoiceProduct: '/mall/invoice/product-edit', //发票服务项目编辑
    getInvoiceMode: '/mall/invoice/invoice-mode', //发票接口列表
    editModeStatus: '/mall/invoice/set-invoice-mode-status', //发票接口开启关闭
    getModeDetail: '/mall/invoice/invoice-mode-detail', //发票详情
    editMode: '/mall/invoice/invoice-mode-edit', //发票接口编辑
    orderHotelList: '/mall/hotel/order-hotel-list', //添加订单酒店列表
    addHotelOrder: '/mall/order/add-hotel-order', //添加酒店预定信息
    userInvoiceList: '/mall/invoice/user-invoice-list', //用户发票列表
    userInvoiceInfo: '/mall/invoice/user-invoice-info', //用户发票信息
    deleteInvoice: '/mall/invoice/user-invoice-del', //删除用户发票信息
    openInvoice: '/mall/invoice/open-invoice', //开电子发票

    /****************    商品板块    ****************/
    // 获取商品分类列表
    getGoodsTypeList: '/mall/goods-category/get-goods-type-list',
    // 获取商品分类详情
    getGoodsTypeInfo: '/mall/goods-category/get-goods-type-info',
    // 获取全部商品分类
    getAllGoodsType: '/mall/goods-category/get-all-goods-type',
    // 添加、修改、删除商品分类
    setGoodsCategory: '/mall/goods-category/set-type',
    // 商品分类排序
    goodsCategorySort: '/mall/goods-category/type-sort',
    // 商品分类排序
    goodDragSort: '/mall/goods-category/drag-sort',
    // 获取商品列表
    getGoodsList: '/mall/goods/get-goods-list',
    // 获取论坛商品列表
    getGoodsListForum: '/mall/goods/get-forum-goods-list',
    // 添加、修改商品信息
    setGoods: '/mall/goods/set-goods',
    // 删除商品
    deleteGoods: '/mall/goods/del-goods',
    getGoodsInfo: '/mall/goods/get-goods-info',
    // 商品分配信息
    allocateGoods: '/mall/goods/allocate-goods',
    // 商品设置分论坛配货
    setForumAllocateNum: '/mall/goods/set-forum-allocate-num',
    // 论坛商品列表
    getForumGoodsList: '/mall/forum-goods/get-forum-goods-list',
    // 论坛商品设置 上下架
    setForumGoodsStatus: '/mall/forum-goods/batch-set-status',
    // 设置分类状态
    setBatchStatus: '/mall/goods-category/batch-set-status',
    // 设置商品上下架状态
    setGoodsStatus: '/mall/goods/batch-set-status',
    //商品列表排序
    goodsSort: '/mall/goods/order-update',

    /****************    会议配置    ****************/
    // 基本信息
    websiteInfo: '/mall/website/info',
    // 默认首页
    websiteDefault: '/mall/website/default',
    // 默认图片
    websiteImage: '/mall/website/default-image',
    // 获取表单数据
    getFormData: '/mall/reg-form/get-form-data',
    // 修改表单显示、必填、删除状态
    setFormStatus: '/mall/reg-form/set-show',
    // 添加、修改表单内容
    updateForm: '/mall/reg-form/set-form',
    // 表单拖拽排序
    formDragSort: '/mall/reg-form/drag-sort',
    // 获取注册表单
    getRegSelected: '/mall/reg-form/get-reg-selected',

    /****************    PC网站配置    ****************/
    // PC网站配置
    pcConfigInfo: '/mall/website/pc-set',
    // pc网站风格配置
    pcConfigStyle: '/mall/website/pc-style',
    // pc首页网站
    pcPageContent: '/mall/website/pc-modules',
    // 编辑
    pcPageContentEdit: '/mall/website/pc-module',
    // 首页内容显示隐藏操作
    pcPageContentSwitch: '/mall/website/pc-switch-show',
    // 新闻模块(列表)
    pcNewsList: '/mall/news/list',
    // 新闻模块(更新)
    pcNewsUpdate: '/mall/news/info',
    // 新闻模块(删除)
    pcNewsDel: '/mall/news/del',
    // 新闻模块(排序)
    pcNewsSort: '/mall/news/order-update',
    // 新闻模块(切换状态)
    pcNewsSwitch: '/mall/news/switch-show',
    // banner模块(列表)
    pcLinkList: '/mall/links/list',
    // banner模块(更新)
    pcLinkInfo: '/mall/links/info',
    // banner模块(删除)
    pcLinkDel: '/mall/links/del',
    // banner模块(排序)
    pcLinkSort: '/mall/links/order-update',
    // banner模块(切换状态)
    pcLinkSwitch: '/mall/links/switch-show',
    // guest模块(列表)
    pcGuestList: '/mall/guest/list',
    // guest模块(更新)
    pcGuestInfo: '/mall/guest/info',
    // guest模块(删除)
    pcGuestDel: '/mall/guest/del',
    // guest模块(排序)
    pcGuestSort: '/mall/guest/order-update',
    // guest模块(切换状态)
    pcGuestSwitch: '/mall/guest/switch-show',
    // button模块(列表)
    pcButtonList: '/mall/button/list',
    // button模块(更新)
    pcButtonInfo: '/mall/button/info',
    // button模块(删除)
    pcButtonDel: '/mall/button/del',
    // button模块(排序)
    pcButtonSort: '/mall/button/order-update',
    // button模块(切换状态)
    pcButtonSwitch: '/mall/button/switch-show',
    // 获取会议配置枚举
    getConfigJson: '/mall/website/enum',
    // PC首页导航栏目配置-获取
    getPcNavList: '/mall/website/pc-nav-modules',
    // PC首页导航栏目是否显示-保存
    setPcNavSwitch: '/mall/website/pc-nav-switch-show',
    // PC首页导航栏目子栏目-保存
    pcNavListUpdate: '/mall/website/pc-module',
    // PC首页导航栏目子栏目-删除
    pcNavListDel: '/mall/website/pc-module-del',
    // PC首页导航栏目-排序
    pcNavListSort: '/mall/website/order-update',

    /****************    用户管理    ****************/
    setIdentity: '/mall/identity/set-identity', // 设置身份类型
    getIdentityList: '/mall/identity/get-identity-list', // 获取身份类型列表
    batchSaveStatus: '/mall/identity/batch-save-status', // 批量设置身份类型状态
    getRegList: '/mall/reg/list', // 获取注册用户列表
    getRegInfo: '/mall/reg/get-reg-info', // 获取注册用户详情
    setRegInfo: '/mall/reg/set-reg', // 添加、修改注册用户信息
    deleteReg: '/mall/reg/batch-del-reg-status', // 删除注册用户
    meetingRegForm: 'mall/front-login/reg-from', // 注册表单数据
    searchUser: '/mall/reg/select-user', // 搜索用户
    getCustomGoodList: '/mall/front-goods/goods-list-v2', // 获取商品列表
    addOrder: '/mall/order/add-order', // 新增订单
    getStaffUserChannelId: '/mall/staff/get-staff-channel-id', // 获取工作人员通道id
    getRegVipList: '/mall/reg/vip-list', //vip列表
    submitAudit: '/mall/reg/verify-form', // 提交审核
    /********************* 论坛管理  ******************/
    getForumList: '/mall/forum/get-forum-list', // 获取论坛列表
    setForum: '/mall/forum/set-forum', // 添加、修改论坛信息
    setForumStatus: '/mall/forum/batch-save-status', // 单个、批量修改论坛状态
    getFourmInfo: '/mall/forum/get-forum-info', // 获取论坛详情
    setForumPermis: '/mall/forum/set-forum-permis', // 设置论坛权限
    delForum: '/mall/forum/del-forum', // 删除论坛
    /********************* 订单管理  *******************/
    getUserOrder: '/mall/order/get-user-order', // 获取用户订单列表
    getOrderList: '/mall/order/get-order-list', // 获取订单列表
    getForumOrderList: '/mall/order/forum-goods-order-list', // 获取论坛订单列表
    getPayType: '/mall/order/get-pay-type', // 获取支付方式
    getOrderInfo: '/mall/order/get-order-details', // 获取订单详情
    setOrderStatus: '/mall/order/audit-order-status', // 修改订单状态
    refundOrderInfo: '/mall/order/refund-index', // 退款
    refundOrder: '/mall/order/edit-refund', // 退款
    exportTask: '/mall/download/add-download-task', // 导出订单
    getPayTypeEnum: '/mall/common/get-pay-type-enum', // 获取支付类型枚举
    delOrder: '/mall/order/del-order', //取消订单
    addAdminOrder: '/mall/order/admin-add-order', //签到系统添加订单

    /********************* 促销,营销  *******************/
    getSaleTiered: '/mall/sale/tiered', // 阶梯促销列表
    tieredCreateUpdate: '/mall/sale/tiered-create-update', // 阶梯促销新增修改
    saleLimitList: '/mall/sale/limit', //限制规则列表
    limitCreateUpdate: '/mall/sale/limit-create-update', //限制规则新增修改
    setTieredStatus: '/mall/sale/tiered-status', //阶梯促销修改状态
    setSaleLimitStatus: '/mall/sale/limit-status', //限制规则修改状态
    getSaleLimitEnum: '/mall/sale/limit-enum', //获取限制规则枚举
    getFullRuleList: '/mall/sale/full-rule-list', //获取满减促销列表
    addFull: '/mall/sale/add-full', //满减促销新增
    editFull: '/mall/sale/edit-full', //满减促销修改
    setFullStatus: '/mall/sale/set-full-status', //满减促销修改开启状态
    delFull: '/mall/sale/del-full', //满减促销删除

    /***************** 支付方式配置 & 发票配置 *************/
    getPayData: '/mall/pay/get-pay-data', //获取支付方式配置
    setPayData: '/mall/pay/set-pay', //设置支付方式配置
    setPayStatus: '/mall/pay/set-pay-status', //设置支付方式状态
    getInvoiceConfigInfo: '/mall/invoice/get-invoice-config-info', // 获取发票配置
    setInvoiceConfig: '/mall/invoice/set-invoice-config', // 设置发票配置
    getTemplateLabel: '/mall/common/get-template-label', // 获取模板标签
    getInvoiceDetails: '/mall/invoice/get-invoice-details', // 获取发票详情
    setOrderInvoice: '/mall/invoice/set-invoice', // 设置发票状态
    getChannelList: '/mall/pay/hotel-pay-channel', //酒店支付渠道列表
    setChannelStatus: '/mall/pay/set-channel-status', //酒店支付渠道开启关闭
    getChannelPaymentList: '/mall/pay/hotel-channel-payment-list', //酒店渠道支付方式列表
    setChannelPayStatus: '/mall/pay/set-channel-pay-status', //酒店渠道支付方式开启关闭
    getChannelPayInfo: '/mall/pay/channel-pay-info', //酒店渠道支付方式详情
    setChannelPayInfo: '/mall/pay/channel-payments-edit', //酒店渠道支付方式编辑
    getChannelDateInfo: '/mall/pay/hotel-channel-date-info', //酒店渠道支付时间信息
    setChannelDateEdit: '/mall/pay/hotel-channel-date-edit', //酒店渠道支付时间编辑

    /*********************** 菜单权限相关    ****************/
    getAdminList: '/mall/admin/list', // 管理员列表
    updateAdmin: '/mall/admin/create-update', // 管理员添加修改
    getAdminRole: '/mall/admin/get-role', // 获取角色列表
    getAdminMeeting: '/mall/admin/meeting-permis', // 获取自定义角色功能模块
    getAdminMenu: '/mall/permis/menu', // 获取当前用户可查看的菜单
    deleteAdmin: '/mall/admin/delete-user', // 删除管理员
    getUserRole: '/mall/admin/get-permis', // 获取用户选择功能模块
    getPermisDataRole: '/mall/admin/permis-data-config-list', // 获取可配置数据权限列表
    setPermisDateRole: '/mall/admin/set-data-permis', // 设置数据权限
    getOnSiteToken: '/mall/admin/get-onsite-token', //获取签到系统token
    /**********************  微网站配置相关  **************************/
    getWebsiteInfo: '/mall/website/mobile-set', // 获取微网站配置
    clearCache: '/mall/website/clear-mobile-cache', // 设置微网站配置
    getMobileStyle: '/mall/website/mobile-style', // 获取微网站风格配置
    getMobileBanners: '/mall/website/mobile-banners', // 获取微网站banner列表
    getMobileBannerInfo: '/mall/website/mobile-banner', // 获取微网站banner详情
    deleteMobileBanner: '/mall/website/mobile-banner-del', // 删除微网站banner
    getMobileNavList: '/mall/website/mobile-nav-modules', // 获取微网站导航栏目列表
    setMobileNavSwitch: '/mall/website/mobile-nav-switch-show', // 设置微网站导航栏目是否显示
    deleteMobileNav: '/mall/website/mobile-nav-del', // 删除微网站导航栏目
    getAdList: '/mall/website/mobile-adseats', // H5广告位列表
    setAdSwitch: '/mall/website/mobile-switch-adseat', // H5广告位是否显示
    getMobileAds: '/mall/website/mobile-ads', // 获取H5广告列表
    getMobileAdInfo: '/mall/website/mobile-ad', // 获取H5广告详情
    deleteMobileAd: '/mall/website/mobile-ad-del', // 删除H5广告
    setMobileSwitch: '/mall/website/mobile-switch-ad', // H5广告是否显示
    setMobileAdSort: '/mall/website/mobile-ad-order-update', // H5广告排序
    setMobileNavSort: '/mall/website/mobile-nav-sort', // H5导航栏目排序
    setMobileNavInfo: '/mall/website/mobile-nav', // H5导航栏目保存
    getH5NewsList: '/mall/minisite-news/list', // H5新闻列表
    getH5NewsInfo: '/mall/minisite-news/info', // H5新闻详情
    h5SwitchShow: '/mall/minisite-news/switch-show', //更改H5新闻状态
    deleteH5News: '/mall/minisite-news/del', //删除H5新闻
    h5NewsSort: '/mall/minisite-news/order-update', //H5新闻排序
    getShareConfig: '/mall/website/mobile-share-wechat', // 微网站获取分享配置
    updateShareConfig: '/mall/website/mobile-share-wechat', // 保存分享配置
    getGoodsSales: '/mall/statistics/goods-sales', // 售票统计

    /*************************  短信邮件公共相关  **************************/
    getTotalItems: '/mall/send/get-total-items', //获取短信邮件(发送、模版)总条数
    getSendBalance: '/mall/send/get-send-balance', //获取用户账户余额
    sendNum: '/mall/send/recipients-num-count', //统计收件人数
    getSendTemplate: '/mall/send/template-list', //获取短信、邮件模版列表
    getSendTemplateTitle: '/mall/send/get-template-title', //获取短信、邮件模版标题
    getSendTemplateInfo: '/mall/send/get-template-info', //获取模版信息
    editSendTemplate: '/mall/send/set-template', //添加或编辑短信、邮件模版
    editSendTemplateStatus: '/mall/send/set-template-status', //变更短信邮件模版状态
    getSendTags: '/mall/send/get-tags', //获取短信邮件标签
    sendUploadFile: process.env.VUE_APP_API_BASE_URL + '/mall/send/custom-upload-file', //短信、邮件自定义上传Excel数据
    sendCustomExecute: '/mall/send/custom-execute', //短信、邮件自定义上传执行发送

    /*************************  短信相关配置  **************************/
    getSmsList: '/mall/send/sms-list', //短信发送列表
    getSmsDetails: '/mall/send/sms-details', //短信发送详情
    getTemplateLog: '/mall/send/sms-template-log', //短信模版发送记录
    getSmsConfig: '/mall/send/sms-config', //发送短信相关配置
    setSmsPreview: '/mall/send/sms-preview', //提交预览短信
    setSmsExecute: '/mall/send/sms-execute', //执行发送短信
    getEmailList: '/mall/send/email-list', //邮件列表
    getEmailDetails: '/mall/send/email-details', //邮件发送详情

    /*************************  邮件相关配置  **************************/
    getEmailConfig: '/mall/send/email-config', // 邮件相关配置
    setEmailPreview: '/mall/send/email-preview', // 邮件预览
    setEmailExecute: '/mall/send/email-execute', // 邮件执行
    setEmailParams: '/mall/send/set-email-param', // 设置邮件参数
    getEmailParams: '/mall/send/email-param-info', // 获取邮件参数配置
    getSendList: '/mall/send/email-list', // 发送记录
    getEmailTemplateLogList: '/mall/send/email-template-log', // 获取邮件模板记录列表
    /*************************  注册参会配置  **************************/
    getRegisterConfig: '/mall/reg/get-config', // 获取注册参会配置
    saveRegisterConfig: '/mall/reg/set-config', // 保存参会注册配置
    getRefundConfig: '/mall/pay/refund-config', // 获取门票退款配置

    /*************************  日程相关配置  **************************/
    getProgramDateList: '/mall/program/get-date-list', // 获取日期列表接口
    getProgramHallList: '/mall/program/get-hall-list', // 获取会场列表接口
    getProgramXuezuList: '/mall/program/get-xuezu-list', // 获取专题分论坛列表接口
    deleteProgramDate: '/mall/program/delete-date', // 删除日期
    deleteProgramHall: '/mall/program/delete-hall', // 删除会场
    deleteProgramClass: '/mall/program/del-class', // 删除学组
    getProgramFayanList: '/mall/program/fayan-type-list', // 获取发言类型列表接口
    getProgramSessionList: '/mall/program/get-session-list', // 获取日程管理界面Session列表接口
    addEditHall: '/mall/program/add-edit-hall', // 新增编辑会场
    addEditDate: '/mall/program/add-edit-date', // 新增编辑日期信息
    addEditXueZu: '/mall/program/add-edit-xuezu', // 新增编辑专题分论坛接口
    getProgramSet: '/mall/program/get-program-set', // 获取日程相关配置接口
    getSearchDutyList: '/mall/program/search-duty-list', // 搜索日程任务列表接口
    getRepeatDateTime: '/mall/program/get-program-time', // 获取日程时间冲突列表
    getRepeatFayan: '/mall/program/new-index', // 同一篇论文多次发言任务
    getNotProgramList: '/mall/program/not-program', // 已评审未排进日程文章
    batchDelProgram: '/mall/program/batch-del', // 批量删除论文信息
    getProgramLogs: '/mall/program/get-program-update-log', // 获取日程更新记录
    clearPragramCache: '/mall/program/clear-program-cache', // 清除日程缓存信息
    batchLiveRemark: '/mall/program/batch-set-live-reamrk', // 批量设置直播备注
    getBatchSessionList: '/mall/program/session-list', // 批量修改session信息获取session列表
    batchSessionEdit: '/mall/program/session-edit', // 批量编辑session信息接口
    getBranchList: '/mall/program/get-branch-list', // 查看未安排学术任务委员名单获取分会列表接口
    verifyMemberDuty: '/mall/program/member-duty', // 校验届次是否有数据
    getMemberDutyList: '/mall/program/get-member-duty-list', // 获取委员名单列表接口
    updateProgramSession: '/mall/program/add-edit-session', // 添加编辑Session信息
    deleteProgramSession: '/mall/program/del-session', // 删除session信息
    setProcessSessionColor: '/mall/program/unit-color', // 设置日程一览表显示颜色
    getProgramEnuList: '/mall/program/get-team-list', // 获取专题会展商列表、活动、会议直播列表
    sortProgramOrderBy: '/mall/program/class-hall-order-by', // 学组会场排序
    getProgramAbsClassList: '/mall/program/get-abs-class-list', // 获取可选论文分类列表接口
    getProgramSessionInfo: '/mall/program/session-info', // 获取session详情信息
    getProgramRepeatList: '/mall/program/get-repeat-list', // 获取冲突任务列表
    getProgramSearchDuty: '/mall/program/search-duty', // 检索学术日程任务讲者信息接口
    searchAbstract: '/mall/program/search-abstract', // 根据标题/ID搜索论文信息
    getProgramInfo: '/mall/program/get-program-info', // 获取日程详情
    saveProgramDuty: '/mall/program/duty-create-update', // 新增修改任务信息
    getProgramFormList: '/mall/program/get-add-form-list', // 获取添加主持、讲者时的回显信息接口
    getDutyInfo: '/mall/program/get-duty-info', // 获取日程任务的详情信息
    delDuty: '/mall/program/duty-delete', // 删除任务信息
    updateCreateProgram: '/mall/program/program-create-update', // 添加更新日程信息
    getRelatedVideos: '/mall/program/get-upload-video-info', // 获取上传视频所需相关信息接口
    getRelatedVideoAuthors: '/mall/program/get-user-list', // 视频上传搜索用户列表接口
    addRelatedVideoUsers: '/mall/program/add-user', // 关联视频上传新增用户接口
    saveProgramRelateVideo: '/mall/program/program-relate-video', // 日程关联视频信息接口
    delProgram: '/mall/program/delete-program', // 删除日程
    batchAddAbstract: '/mall/program/batch-add-abstract', // 根据论文编号批量添加日程
    cancelProgramVideo: '/mall/program/cancel-program-video', // 取消日程关联视频信息
    validUsername: '/mall/program/username-meeting', // 会议管理查询用户是否存在
    programImportList: '/mall/program/program-export-list', // 获取导入日程任务列表
    saveAddImportTask: '/mall/program/add-program-export', // 新增导入任务接口
    getProgramImportInfo: '/mall/program/get-program-import-info', // 获取日程导入任务详情接口
    setProgramImportData: '/mall/program/process-program-data', // 处理导入日程数据接口
    programOrderBy: '/mall/program/orderby', // session列表保存排序
    programDutyOrderBy: '/mall/program/duty-orderby', // 学术任务排序

    editCategory: '/mall/program-config/add-edit-category', // 新增编辑发言类型接口
    sortType: '/mall/program-config/order-update-type', // 类别排序
    deleteType: '/mall/program-config/delete-type', // 删除类别信息
    getProgramConfig: '/mall/program-config/get-program-set-info', // 获取日程配置详情接口
    getSessionSubscrilbeList: '/mall/program-config/session-sub-record', // 获取session订阅记录接口
    getProgramSubscrilbeList: '/mall/program-config/session-sub-record-program', // 获取日程订阅记录接口
    getSmsHistoryList: '/mall/program-config/sms-record-list', // 获取短信发送记录接口
    setProgramConfig: '/mall/program-config/set-program', // 编辑日程显示配置
    getSlideUserList: '/mall/program-config/slide-user-list', // 获取幻灯系统管理员列表
    addSlideUser: '/mall/program-config/add-edit-slide-user', // 新增编辑幻灯系统管理员
    delSlideUser: '/mall/program-config/del-admin-user', // 删除幻灯系统管理员
    getSlideConfig: '/mall/program-config/get-slide-set-info', // 获取幻灯系统配置
    saveSlideConfig: '/mall/program-config/add-edit-slide-config', // 保存幻灯系统配置信息
    getLocalVideoList: '/mall/program-config/record-local-video-list', // 获取本地视频列表
    getCloudVideoList: '/mall/program-config/get-record-video-list', // 获取云录制视频列表接口
    submitSyncVideo: '/mall/program-config/sync-video', // 同步视频信息
    getAddLimit: '/mall/program-config/get-limit-rule', // 获取日程添加次数限制列表
    addProgramLimit: '/mall/program-config/add-program-limit', // 添加编辑讲者添加次数
    delProgramLimit: '/mall/program-config/del-program-limit', // 删除讲者添加次数
    getProgramConfirmList: '/mall/program-confirm/program-confirm-list', // 获取学术任务确认列表接口
    getUserProgressMultiple: '/mall/program-confirm/progress-multiple', // 获取某人的学术任务确认列表
    /*************************  稿件管理配置  **************************/
    getSubmissionInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/set/info', // 文稿全局配置
    updateSubmissionInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/set/update', // 文稿配置修改
    getSubmissionPay: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/set/pay', // 获取支付配置
    updateSubmissionPay: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/set/update-pay', // 修改支付配置

    // 稿件分类
    getSubmissionClassList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/class/list', // 搜索分类信息
    updateSubmissionClass: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/class/update', // 修改分类信息
    getClassInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/class/info', // 查看分类信息
    updateSubmissionClassStatus: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/class/status', // 修改状态
    createSubmissionClass: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/class/create', // 创建分类信息
    deleteSubmissionClass: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/class/delete', // 删除分类信息
    sortSubmissionClass: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/class/sort', // 排序

    // 渠道配置
    getSubmissionChannelList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/channel/list', // 获取渠道列表
    createSubmissionChannel: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/channel/create', // 创建渠道信息
    updateSubmissionChannel: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/channel/update', // 修改渠道信息
    sortSubmissionChannel: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/channel/sort', // 排序
    deleteSubmissionChannel: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/channel/delete', // 删除
    updateSubmissionChannelStatus: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/channel/status', // 修改状态
    getSubmissionChannelInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/channel/info', // 获取渠道信息
    getChnanelFormData: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/list', // 获取渠道表单配置
    changeFormItemStatus: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/status', // 修改表单项是否收集状态
    getParentFormList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/parents', // 获取父级表单
    createFormItem: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/create', // 新增表单项
    updateFormItem: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/update', // 修改表单项
    getFormItemInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/info', // 查询表单项信息
    formSort: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/sort', // 表单排序

    getAbstractList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/list', // 获取稿件列表
    getAbstractDetail: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/info', // 获取稿件详情
    getAuthorInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/author/info', // 获取作者详情
    createAbstractAuthor: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/author/create', // 添加作者
    editAuthorInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/author/update', // 修改作者
    delAuthorInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/author/delete', // 删除作者
    getAbstractAuthorList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/author/list', // 获取作者列表
    authorSort: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/author/sort', // 作者排序
    getAuthorFormList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/list', // 获取表单列表
    getOrganizeList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/organize/list', // 获取单位列表
    delOrgListItem: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/organize/delete', // 删除单位列表
    updateOrgListItem: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/organize/update', // 修改单位列表
    addOrgListItem: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/organize/create', // 添加单位列表
    sortOrgList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/organize/sort', // 单位排序

    changeAuthorStatus: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/author/status', // 修改通讯作者||是否为发言作者 状态
    addAbstract: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/create', // 新增渠道
    editAbstract: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/update', // 编辑渠道
    getAbstractClass: process.env.VUE_APP_API_GO_BASE_URL + '/mall/contribute/v1/globe/class', // 渠道分类列表
    deleteAbstractListItem: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/delete', // 删除稿件
    getAbstractListDetail: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/info', // 获取稿件列表管理-稿件详情
    getHireList: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/review/categorys', // 获取录用列表
    submitAbstractAudit: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/status', // 提交稿件审核
    getFormOptions: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/form/options', // 获取表单选项值
    updateFile: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/annex', // 保存文件 壁报 全文 PPT 摘要全文 视频
    getFormInfo: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/forms', // 获取表单
    // 稿件统计
    getAbstractClassStatistics: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/static/abstract/class', // 稿件分类统计
    getAbstractStatistics: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/static/abstract', // 稿件列统计
    getAbstractUserStatistics: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/static/abstract/user', // 稿件投稿者统计
    // 稿件导出
    getExportWordOptions: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/export/word-options', // 获取导出world筛选项
    submitExportWord: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/export/word', // 提交导出word
    submitExportAnnex: process.env.VUE_APP_API_GO_BASE_URL + '/mall/submission/abstract/export/annex', // 提交导出附件
    // 稿件信息、邮件模板
    getAbstractTemplateInfo: '/mall/send/get-template-info', // 获取稿件模板信息
    getAbstractTemplateTags: '/mall/send/get-tags', // 获取短信邮件标签
    setAbstractTemplate: '/mall/send/set-template', // 添加或编辑短信、邮件模版

    //工作人员模块
    getStaffConfig: '/mall/staff/staff-config', //获取配置信息
    setStaffConfig: '/mall/staff/set-staff-config', //设置配置信息
    getStaffJobList: '/mall/staff/staff-post-list', //工作岗位列表
    addStaffJob: '/mall/staff/add-staff-post', //添加工作岗位
    editStaffJob: 'mall/staff/edit-staff-post', // 编辑工作岗位
    delStaffJob: '/mall/staff/del-staff-post', //删除工作岗位
    getStaffList: '/mall/staff/staff-list', //工作人员列表
    getStaffWorkList: '/mall/common/staff-form-config', // 获取工作人员身份 现场工作岗位列表
    getStaffSelectUser: 'mall/staff/select-staff', // 查询工作人员信息
    addStaffUser: 'mall/staff/add-staff', // 添加工作人员
    delStaffUser: 'mall/staff/del-staff', // 删除工作人员
    getStaffUserInfo: 'mall/staff/get-staff-info', // 获取工作人员用户信息
    editStaffUser: '/mall/staff/edit-staff', // 提交工作人员编辑

    // 渠道相关接口
    getRegChannelList: '/mall/reg/channel-list', //渠道列表
    getChannelConfig: '/mall/reg/channel-config', //获取渠道配置信息
    addChannel: '/mall/reg/add-channel', //添加渠道
    editChannel: '/mall/reg/edit-channel', //编辑渠道
    openChannel: '/mall/reg/open-channel', //设置渠道开启状态
    deleteChannel: '/mall/reg/del-channel', //删除渠道
    getVipIdentity: '/mall/vip-set/identity', //获取VIP参会身份标识列表
    delVipIdentity: '/mall/vip-set/identity-delete', // 删除vip参会身份标识
    editVipIdentity: '/mall/vip-set/identity-update', // 修改vip参会身份标识
    getVipTreatment: '/mall/vip-set/treatment', //获取VIP参会待遇列表
    editVipTreatment: '/mall/vip-set/treatment-update', // 修改参会待遇标识
    delVipTreatment: '/mall/vip-set/treatment-delete', // 删除参会待遇标识列表
    getChannelGoodsList: '/mall/goods/goods-list', //获取商品列表
    editFaculty: '/mall/vip-set/edit-faculty', // 修改用户身份待遇信息
    // 用户导入
    getImportEnum: '/mall/reg/get-import-enum', //导入数据枚举
    downloadUserImportTemplate: '/mall/reg/import-template', //导入模板下载
    importUser: (process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API_BASE_URL + '/mall/reg/import-user' : process.env.VUE_APP_API_BASE_URL + '/mall/reg/import-user') + '?v=' + +new Date(), //导入数据
    getExpertTrip: '/mall/guest/expert-trip' // 专家行程
};
